module.exports = __webpack_public_path__ + "img/GTO.20e7f35d.svg";